import { CheckboxProps } from "@hi-interactive-admin/simulador-kinto";
import { useCallback, useEffect, useMemo, useState } from "react";
import { VehicleService } from "../../../services/VehicleService";

const vehicleService = new VehicleService();

const useRentalTypesCustomHook  = () => {
  //INCIO Tipo de Aluger
  const [rentalTypes, setRentalTypes] = useState<CheckboxProps[]>([])
  const [rentalTypeSettings, setRentalTypeSettings] = useState<any[]>([]);

  const handleToggleSelectRentalTypeCallback = useCallback((optionLabel:string) => () => {
    setRentalTypes((rows) => 
      rows.map(row => {
        if ( row.label === optionLabel){
          // row.checked = !row.checked;
          row = {
            ...row,
            checked: !row.checked
          }
        }
        return row;
      })
    )
  },[]);

  useEffect(() => {
    const populateRentalTypesData = async () => {
      let rentTypeOptions: CheckboxProps[] = [];
      const data = await vehicleService.getRentalTypes();
      if(data && data.succeeded === true) {
        rentTypeOptions = data.value.map((element:any) => {
          return { 
            label:element.value,
            checked:false,
            onClick: handleToggleSelectRentalTypeCallback(element.value),
          }
        });

        setRentalTypes((rows) => {
          if (rows.length === 0 ){
            return rentTypeOptions;
          }
          return rows;
        });
        setRentalTypeSettings(data.value)
      }
    }
    populateRentalTypesData();
  }, [handleToggleSelectRentalTypeCallback]);

  const rentalTypesMemo = useMemo(() => rentalTypes,[rentalTypes])
  //FIM Tipo de Aluger
  return { rentalTypes, setRentalTypes, rentalTypesMemo, rentalTypeSettings };
};

export default useRentalTypesCustomHook;